export default import.meta.ROLLDOWN_FILE_URL_PVlmLwJ6FyCLdcCAHHh9dg